import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslateService } from '@ngx-translate/core';

import { AggregatedStatus, InstallationItemGateway } from '@vi-iot/client';

import { InstallationsStore } from '@store';

import { matTooltipSetter } from '../../../../shared/functions/mat-tooltip-setter/mat-tooltip-setter';
import { LiveUpdatesService } from '../../../../shared/live-updates/live-updates.service';

@Component({
  selector: 'app-installation-item-status',
  templateUrl: './installation-item-status.component.html',
  styleUrls: ['./installation-item-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InstallationItemStatusComponent implements OnInit, OnDestroy {
  @ViewChildren(MatTooltip)
  set matTooltip(queryList: QueryList<MatTooltip>) {
    matTooltipSetter(queryList);
  }

  readonly aggregatedStatus = AggregatedStatus;

  @Input() liveUpdate: boolean;
  @Input() gateway: InstallationItemGateway;
  @Input() isColdSystem: boolean;

  constructor(
    private liveUpdatesService: LiveUpdatesService,
    private translation: TranslateService,
    public installationsStore: InstallationsStore
  ) {}

  ngOnInit(): void {
    if (this.liveUpdate && this.gateway) {
      this.liveUpdatesService.subscribeInstallationsAggregatedStatus(this.gateway.serial);
    }
  }

  ngOnDestroy(): void {
    if (this.liveUpdate && this.gateway) {
      this.liveUpdatesService.unsubscribeInstallationsAggregatedStatus(this.gateway.serial);
    }
  }

  getTooltip(): string {
    return this.gateway?.lastStatusChangedAt
      ? `${this.getTranslation()}: ${new Date(this.gateway.lastStatusChangedAt).toLocaleString()}`
      : '';
  }

  private getTranslation(): string {
    return this.translation.instant('+INSTALLATIONS.INSTALLATION.LAST_STATUS_CHANGED');
  }
}
